import React from 'react';

const WelcomeStep = ({ onNext, onSkip }) => {
  return (
    <div className="text-center">
      <h2 className="text-3xl font-bold text-gray-900 mb-4">Welcome to Apprecio!</h2>
      <p className="text-lg text-gray-600 mb-8">
        Let's get your team set up in just a few quick steps.
      </p>

      <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6 mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">What we'll set up:</h3>
        <ul className="text-left space-y-3 text-gray-700">
          <li className="flex items-start">
            <span className="text-indigo-600 mr-2">✓</span>
            <span>Connect your Slack workspace for seamless team appreciations</span>
          </li>
          <li className="flex items-start">
            <span className="text-indigo-600 mr-2">✓</span>
            <span>Import your team members to get started quickly</span>
          </li>
        </ul>
      </div>

      <div className="flex justify-center space-x-4">
        <button
          onClick={onNext}
          className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium"
        >
          Let's Get Started
        </button>
        <button
          onClick={onSkip}
          className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
        >
          Skip for Now
        </button>
      </div>
    </div>
  );
};

export default WelcomeStep;
